import { uniqueArr } from 'src/pages/Policy/utils/fns';
import { EnableDisableEnum } from 'src/pages/Policy/utils/types';
import { create } from 'zustand';

export type FilterStatusArrType = (EnableDisableEnum | null)[];
interface PolicyTabsStore {
  // activeTab: string;
  tabClicked: string[];
  filters: string[];
  filterStatusArr: FilterStatusArrType;
  allPanelComponents: React.MemoExoticComponent<() => JSX.Element>[];
  setAllPanelComponents: (
    allPanelComponents: React.MemoExoticComponent<() => JSX.Element>[]
  ) => void;
  setFilterStatusArr: (filterStatusArr: FilterStatusArrType) => void;
  setFilters: (filters: string[]) => void;
  clickTab: (tab: string) => void;
  clearTabClicked: () => void;
}
export const usePolicyTabsStore = create<PolicyTabsStore>((set) => ({
  activeTab: '',
  tabClicked: [],
  filters: [],
  filterStatusArr: [],
  allPanelComponents: [],
  setAllPanelComponents: (
    allPanelComponents: React.MemoExoticComponent<() => JSX.Element>[]
  ) => set({ allPanelComponents }),
  setFilterStatusArr: (filterStatusArr: FilterStatusArrType) =>
    set({ filterStatusArr }),
  setFilters: (filters: string[]) => set({ filters }),
  clearTabClicked: () => set({ tabClicked: [] }),
  clickTab: (tab: string) => {
    console.log('clickTab', tab);
    set((state: any) => ({
      // activeTab: tab,
      tabClicked: uniqueArr([...state.tabClicked, tab]),
    }));
  },
}));
